import React from 'react';
import { useDispatch } from 'react-redux';

import Modal from 'modals/Modal';
import { hideModal } from 'store/main/ducks/modal';
import { humanDate } from 'utils/date';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const GradProgramContactSeeMoreInfoModal = ({
  contact,
}: {
  contact: {
    email: string;
    firstName: string;
    lastName: string;
    interestedInDegreeProgram?: string;
    expectedEnrollmentDate?: string;
    notes?: string;
    created: string;
  };
}) => {
  const dispatch = useDispatch();
  return (
    <Modal
      title={
        /* TRANSLATORS: Grad Program admin modal that shows contact details */
        getText('More info')
      }
      onClose={() => {
        dispatch(hideModal());
      }}
      data-qa-id="grad-program-contact-see-more-info-modal"
    >
      <>
        <p>
          {getText('Email')}: {contact.email}
        </p>
        <p>
          {getText('First name')}: {contact.firstName}
        </p>
        <p>
          {getText('Last name')}: {contact.lastName}
        </p>
        {contact.interestedInDegreeProgram ? (
          <p>
            {getText('Interested in degree program')}:{' '}
            {contact.interestedInDegreeProgram}
          </p>
        ) : null}
        <p>
          {getText('Expected enrollment date')}:{' '}
          {contact.expectedEnrollmentDate}
        </p>
        <p>
          {getText('Notes')}: {contact.notes}
        </p>
        <p>
          {getText('Date Shared')}: {humanDate(contact.created)}
        </p>
      </>
    </Modal>
  );
};

export default GradProgramContactSeeMoreInfoModal;
